module.exports = __webpack_public_path__ + "first-20-hologram.jpg?1337fd986991b1272c47206600c841b1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20-hologram.jpg
// module id = 457
// module chunks = 0